module.exports = __webpack_public_path__ + "static/media/google.f564fc3b.png";